
import React, { useEffect } from 'react';

interface ExtensionRequiredPopupProps {
  onClose: () => void;
}

const ExtensionRequiredPopup: React.FC<ExtensionRequiredPopupProps> = ({ onClose }) => {
  useEffect(() => {
    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleEscape);

    return () => {
      document.removeEventListener('keydown', handleEscape);
    };
  }, [onClose]);

  return (
    <div className="modal show d-block" style={{ backgroundColor: 'rgba(15, 23, 42, 0.6)', backdropFilter: 'blur(4px)' }} tabIndex={-1} onClick={onClose}>
      <div className="modal-dialog modal-dialog-centered" onClick={(e) => e.stopPropagation()}>
        <div className="modal-content border-0 shadow-lg rounded-4 overflow-hidden text-center p-4">
          <div className="mb-4">
            <div className="bg-primary bg-opacity-10 p-3 rounded-circle d-inline-block mb-3">
              <i className="bi bi-puzzle text-primary fs-2"></i>
            </div>
            <h4 className="fw-bold">Extension Required</h4>
            <p className="text-muted small">The AI Shopping Cart Chrome extension is required for the agent to research prices on your behalf.</p>
          </div>
          
          <div className="mb-4">
            <a href="https://chromewebstore.google.com/detail/ai-shopping-cart/bhpgolaacmlhpoflfomangjboeombkkg" target="_blank" rel="noopener noreferrer" className="d-inline-block transition-hover">
              <img src="/chrome-web-store-badge.png" alt="Available in the Chrome Web Store" style={{ height: '58px' }}/>
            </a>
          </div>

          <button className="btn btn-light w-100 py-2 text-muted small" onClick={onClose}>
            Maybe later
          </button>
        </div>
      </div>
    </div>
  );
};

export default ExtensionRequiredPopup;
